import { createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import * as ExhibitionActions from './exhibition.actions';
import { ExhibitionDto } from '@api/rest';

export const exhibitionsFeatureKey = 'exhibitions';

export interface State extends EntityState<ExhibitionDto> {
  selected: string;
}

export const adapter: EntityAdapter<ExhibitionDto> = createEntityAdapter<ExhibitionDto>({
  selectId: exhibition => exhibition.id
});

export const initialState: State = adapter.getInitialState({
  selected: undefined
});


export const reducer = createReducer(
  initialState,
  on(ExhibitionActions.loadExhibitionsSuccess, (state, action) =>
    adapter.setAll(action.exhibitions, state)
  ),
  on(ExhibitionActions.getExhibitionSuccess, (state, action) =>
    adapter.upsertOne(action.exhibition, state)
  ),
  on(ExhibitionActions.setSelectedExhibition, (state, action) =>
    ({ ...state, selected: action.id })
  )
);


export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
